export default function setFooterMenu() {
    document.querySelectorAll('.menu-toggle').forEach(toggle => {
        toggle.addEventListener('click', () => {
            if (window.innerWidth >= 768) return;

            const content = toggle.nextElementSibling;
            const icon = toggle.querySelector('.icon');

            if (content.classList.contains('open')) {
                // CLOSE
                content.style.maxHeight = content.scrollHeight + 'px';

                requestAnimationFrame(() => {
                    content.style.maxHeight = '0px';
                    content.classList.remove('open');
                    content.classList.add('opacity-0');
                    toggle.classList.remove('mb-16');
                });
            } else {
                // OPEN
                content.classList.add('open');
                content.classList.remove('opacity-0');

                content.style.maxHeight = content.scrollHeight + 'px';
                toggle.classList.add('mb-16');

                content.addEventListener('transitionend', function handler() {
                    content.style.maxHeight = 'none';
                    content.removeEventListener('transitionend', handler);
                });
            }

            icon.classList.toggle('rotate-180');
        });
    });
}
